import { useAnalytics } from "@codat/analytics";
import { SelectInput as OrchardSelectInput } from "@codat/orchard-ui";
import {
  SelectInputProps as OrchardSelectInputProps,
  SelectInputValue,
} from "@codat/orchard-ui/dist/es/components/SelectInput";
import React, { forwardRef } from "react";

interface SelectInputProps extends OrchardSelectInputProps {
  inputName: string;
  eventProperties?: Record<string, unknown>;
}

export const SelectInput = forwardRef<HTMLButtonElement, SelectInputProps>(
  function SelectInput(props, ref) {
    const {
      inputName,
      eventProperties,
      handleSelectedItemChange,
      ...selectInputProps
    } = props;
    const { sendEvent } = useAnalytics();

    const handleSelectedItemChangeWithTracking = (
      selectedItem: SelectInputValue | null | undefined
    ) => {
      sendEvent(`${inputName} Select - Change`, {
        ...eventProperties,
        value: selectedItem?.label,
      });
      if (handleSelectedItemChange) {
        handleSelectedItemChange(selectedItem);
      }
    };

    return (
      <OrchardSelectInput
        ref={ref}
        {...selectInputProps}
        handleSelectedItemChange={handleSelectedItemChangeWithTracking}
      />
    );
  }
);
